export default {
  en: {
    nav: {
      home: 'HOME',
      works: 'PORTFOLIO',
      about: 'ABOUT',
      business: 'SERVICE',
      service: 'CLIENT',
      contact: 'CONTACT'
    },
    footer: [{
      links_title: 'LINKS',
      links_content: ['HOME', 'PORTFOLIO', 'ABOUT', 'SERVICE', 'CLIENT', 'CONTACT']
    }, {
      contacts_title: 'CONTACTS',
      contacts_content: [{
        international_title: 'INTERNATIONAL',
        international_name: 'Sasha X. Wen',
        international_email: 'sasha.wen@oib-china.com',
      }, {
        domestic_title: 'DOMESTIC',
        domestic_name1: 'Emily Chen&nbsp;&nbsp;&nbsp;&nbsp;',
        domestic_email1: 'emily.chen@oib-china.com',
        domestic_name2: 'Emily Chen&nbsp;&nbsp;&nbsp;&nbsp;',
        domestic_email2: ' emily.chen@oib-china.com',
      }, {
        recruitment_title: 'RECRUITMENT',
        recruitment_name: 'Icy Yu&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
        recruitment_email: 'hr@oib-china.com',
      }]
    }, {
      partners_title: 'PARTNERS'
    }, {
      wechataccounts_title: 'WECHAT ACCOUNTS',
      wechataccounts_content: ['OIB.CHINA', 'OIB.IBC', 'Coscreate']
    }],
    pages: {
      public: {
        time: 'TIME',
      },
      news: {
        label: 'NEWS',
        link: 'LINK',
        acknowledgments: 'ACKNOWLEDGMENTS',
        no_more_result: 'There is no more News :(',
        business_modules_title: 'OIB.CHINA the Key Four Enpowering Services',
        business_modules: [{
          imgUrl: require('../../assets/img/business/business1.png'),
          title: 'Brand Enpowering Management',
          introduce: 'Core services include branding strategy, product design, channel development, launching promotion, consumer communication and etc.',
        }, {
          imgUrl: require('../../assets/img/business/business2.png'),
          title: 'Global Creative Hub &\n' +
          'Innovative Supply Chain',
          introduce: 'By strategically collaborating with 10+ world renowned creative design companies from the fashion and beauty industry, OIB is enabling to provide comprehansive supply-chain services from product design, mock-ups, structure development, packaging to product realization.'
        }, {
          imgUrl: require('../../assets/img/business/business3.png'),
          title: 'Mini Program & Product Output',
          introduce: 'By gathering up to 30 premium OEM and materials suppliers, OIB has established an output platform of finished goods to mainly support the entrepreneurial brands.'
        }, {
          imgUrl: require('../../assets/img/business/business4.png'),
          title: 'Cutting-age Incubator for Entrepreneurial Brand',
          introduce: 'By collaborating with Tmall, giant e-commerce in China, OIB has been successfully hosting the venture competition of emerging brands -- C-Beauty Inno-Brand -- to provide a series of strategic supports, including platform stationing, enpowered training, investment financing and etc.'
        }],
        business_title: 'OIB.CHINA the Nine Businesses under Key Four Services',
        businesses: [{
          title: 'Brand Strategy',
          introduce1: 'Closely keeping up with the upgrading appeal of consumer, creating fashionable brands and making brand a profitable business.',
          introduce2: 'Businesses: brand positioning, brand building, product strategy, signature product design.'
        }, {
          title: 'Business Intelligence',
          introduce1: 'In-depth insight of the new era user, business strategy of connection between brand and consumer, consultation and planning of strategic marketing.',
          introduce2: 'Businesses: consumer study, market research, distribution marketing, public relation and marketing theory.'
        }, {
          title: 'Super Product',
          introduce1: 'By identifying the consumption pain points from upgrading appeals to create "101 Star Product" that efficiently stimulating thr attraction of brand. "Star Factory". ',
          introduce2: 'Businesses: product positioning, product concept, interactive packaging, formula development, social media promotion, distribution strategy.'
        }, {
          title: 'Creative Design',
          introduce1: 'By discovering the international standards of creativity to develope and present the innovative packaging designs.',
          introduce2: 'Businesses: graphic visual design, creative structural design, VI design and etc.'
        }, {
          title: 'Creative Video',
          introduce1: 'Senior planning team, product-oriented customized videos, seasonal and annual package services.',
          introduce2: ''
        }, {
          title: 'Creative Communication',
          introduce1: 'Explore tipping points by combining hot topics and trendy ideas to provide the most effective mode of brand promotion.',
          introduce2: 'Businesses: customized online and offline communication strategy, TVC, microcinema, H5 and etc.'
        }, {
          title: 'Supply and Purchase',
          introduce1: 'Flexible yet efficient system of supply chain management guarantees the highest speed, the best quality, the lowest cost in process of production.',
          introduce2: 'Businesses: material sourcing, cost accounting, material buying, quality controlling and etc.'
        }, {
          title: 'Product Output',
          introduce1: 'Is committed to create the best-selling product to the Chinese market.',
          introduce2: 'Businesses: brand incubator, product development, selling point identification, product registration, production management and finished product output.'
        }, {
          title: 'Procedure Control',
          introduce1: 'The specialized management team and mature quality control system of product are gathered to buildup a creativity-driven supply chain. ',
          introduce2: 'Businesses: raw material control, sample evaluation, production supervision, progress management, finished product detection, product warehousing, after-sales service and etc.'
        }]
      },
      work: {
        project: 'PROJECT',
        no_more_result: 'There is no more Works :('
      },
      service: {
        letter: 'LETTER',
        industry: 'INDUSTRY',
        project: 'PROJECT',
        introduce: 'OIB.CHINA has helped more than 200 new consumer brands to achieve brand growth, and is becoming the leading brand-growth accelerator and new brand incubator in CHINA\'s new consumer goods field.',
        classification1: 'Skincare',
        classification2: 'Makeup',
        classification3: 'Masks',
        classification4: 'Personal Care',
        classification5: 'Mom and Baby',
        classification6: 'Food'
      },
      about: {
        introduction: 'INTRODUCTION',
        service: 'SERVICE',
        composition: 'COMPOSITION',
        parter: 'PARTNER',
        philosophy: 'PHILOSOPHY',
        clients: 'CLIENTS',
        ip: 'INTELLECTUAL PROPERTY',
        vision: 'VISION',
        awards: 'NEWS',
        people: 'KEY MEMBERS',
        peopleList: [{
          photoUrl: require('../../assets/img/about/people/wuzhigang.jpg'),
          name: 'Wu, Zhigang',
          title: 'OIB.China Founder and General Manager',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/chenjun.jpg'),
          name: 'Chen, Jun',
          title: 'Vice-General Manager of Creative Supply Chain',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/nongqian.jpg'),
          name: 'Nong, Qian',
          title: 'Vice-General Manager of Intergrated Marketing',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/fenghao.jpg'),
          name: 'Feng, Hao',
          title: 'Supply Chain Director',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/aiwentao.jpg'),
          name: 'Ai, Wentao',
          title: 'Art Director',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/linzhanhua.jpg'),
          name: 'Lin, Zhanhua',
          title: 'Product Director',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/huanghe.jpg'),
          name: 'Huang, He',
          title: 'Associate Account Director',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/yuxiaohu.jpg'),
          name: 'Yu, Xiaohu',
          title: 'Account Director',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/chenyanan.jpg'),
          name: 'Chen, Yanan',
          title: 'Business Account Director',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/linzhipin.jpg'),
          name: 'Lin, Zhipin',
          title: 'Senior Account Manager',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/jinjing.jpg'),
          name: 'Jin, Jing',
          title: 'Account Director',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/wenxiasha.jpg'),
          name: 'Sasha Xiashan Wen',
          title: 'Senior Product Manager, International Project Manager',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/panliang.jpg'),
          name: 'Pan, Liang',
          title: 'Director of Business Intelligence and Brand Strategy',
          intro: '<br><br><br>'
        }, {
          photoUrl: require('../../assets/img/about/people/zhuqianru.jpg'),
          name: 'Zhu, Qianru',
          title: 'Assistant Director of OIB.DAV',
          intro: '<br><br><br>'
        }]
      },
      contact: [{
        address_title: 'Address',
        address_content: 'RM 108-110, FL 1, Gate 691,<br> 691 Quxi Rd,<br>Huangpu District,Shanghai,China<br><br>',
        business_title: 'Business',
        business_content: ' Account Service<br>Emily Chen<br> +86 186-1611-4594<br>emily.chen@oib-china.com'
      }, {
        address_title: 'Address',
        address_content: ' RM 2005-2006,North Tower,<br>Poly V Place,11 Xiancun Rd, Zhujiang New Town,<br/>Tianhe District, Guangzhou, China<br><br>',
        phone_title: 'Phone',
        phone_content: '+86 (020) 3855-6155<br><br>',
        business_title: 'Business',
        business_content: ' Brand Marketing<br/>Lizhen Peng<br> +86 135-6035-9426<br>peng@oib-china.com<br>'
      }, {
        business_title: 'Business',
        business_content: ' Lizhen Peng<br> +86 135-6035-9426<br>peng@oib-china.com<br>'
      }, {
        business_title: 'Business',
        business_content: 'June Chen<br> +86 138-2216-2619<br>june.chen@oib-china.com<br>'
      }, {
        address_title: 'Address',
        address_content: ' 神戸市中央区港島南町５−５−２<br>神戸国際ビジネスセンター６０５美研創新（株）内<br><br>',
        business_title: 'Business',
        business_content: 'Administration<br/>Miss Zhu<br> +86 136-3238-4519<br>zhuzhiyi@oib-china.com<br>'
      }, {
        recruitment_title: 'Recruitment',
        recruitment_content: 'Vicky Xin<br> +86 (020) 3855-6155<br>vicky@oib-china.com<br>'
      }]
    }
  },
  zh_cn: {
    nav: {
      home: '首页',
      works: '案例',
      about: '关于我们',
      business: '业务',
      service: '客户',
      contact: '联系我们'
    },
    footer: [{
      links_title: '链接',
      links_content: ['首页', '案例', '关于我们', '业务', '客户', '联系我们']
    }, {
      contacts_title: '联络',
      contacts_content: [{
        international_title: '国际商务：',
        international_name: '温夏莎',
        international_email: 'sasha.wen@oib-china.com',
      }, {
        domestic_title: '商务联系：',
        domestic_name1: '陈亚男',
        domestic_email1: 'emily.chen@oib-china.com',
        domestic_name2: '陈亚男',
        domestic_email2: 'emily.chen@oib-china.com',
      }, {
        recruitment_title: '人才招募：',
        recruitment_name: '余晓珊',
        recruitment_email: 'hr@oib-china.com',
      }]
    }, {
      partners_title: '合作伙伴'
    }, {
      wechataccounts_title: '公众号',
      wechataccounts_content: ['OIB品牌增长引擎', '新锐品牌研学社']
    }],
    pages: {
      public: {
        time: '时间',
      },
      news: {
        label: '新闻',
        link: '链接',
        acknowledgments: '鸣谢',
        no_more_result: '没有更多新闻了！:(',
        business_modules_title: 'OIB.CHINA旗下四大品牌赋能业务模块',
        business_modules: [{
          imgUrl: require('../../assets/img/business/business1.png'),
          title: '品牌赋能管理',
          introduce: '核心业务包括品牌战略定位、超级产品打造、渠道品牌塑造、品牌终端地推广、品牌消费者沟通与传播等。',
        }, {
          imgUrl: require('../../assets/img/business/business2.png'),
          title: '全球虚拟设计中心与创意供应链',
          introduce: '与国内及国际十余家最为领先的美尚领域的产品设计公司形成战略合作，实现从产品设计、打样成型、模具开发、包装实现的完整业务。'
        }, {
          imgUrl: require('../../assets/img/business/business3.png'),
          title: '做货小程序及产品输出',
          introduce: '与尚美业近30家优质OEM与包材供应商打造面向中小品牌创业者的成品输出平台。'
        }, {
          imgUrl: require('../../assets/img/business/business4.png'),
          title: '新锐品牌创业孵化器',
          introduce: '与中国最大的电商平台天猫共同打造新锐品牌创业大赛，为初创品牌提供平台入驻、培训赋能、投融服务等一系列战略支持。'
        }],
        business_title: 'OIB.CHINA为新一代品牌赋能，将所有业务覆盖内容划分为9大业务',
        businesses: [{
          title: '品牌策略',
          introduce1: '紧跟消费者升级步伐，打造新世纪下全新的时尚品牌，让品牌成为一门有利可图的生意；',
          introduce2: '业务包含：品牌定位、品牌塑造、产品战略、品牌型明星产品策划。'
        }, {
          title: '商业智慧',
          introduce1: '深入洞察新一代用户，提供品牌与新一代用户连接的生意战略、行销战略的创意策划与咨询服务；',
          introduce2: '业务包含：消费者调研、市场研究、渠道行销、公关会议策划、营销法研究。'
        }, {
          title: '超级产品',
          introduce1: '创造<strong>101星品牌</strong>,深挖消费升级下消费痛点，打造自带流量驱动的<strong>星</strong>产品，引爆品牌驱动的全新动力引擎；',
          introduce2: '<strong>创星工厂</strong>业务包括：产品功能定位、产品创新概念、创新互动包装、配方工艺开发建议、热点社交推广、商业渠道策略。'
        }, {
          title: '创意设计',
          introduce1: ' 洞悉国际创意水准，最新原创实力完美演绎，灵感荟萃的包装开发，让消费者一眼就爱上；',
          introduce2: '业务包含：平面视觉设计、产品造型结构创新设计、视觉VI设计等。'
        }, {
          title: '创意视频',
          introduce1: '紧跟当下潮流视频创意形式，时尚快消领域资深策略团队整体策划，以产品销售为导向制定视频内容，提供季度、年度品牌视频企划。',
          introduce2: ' '
        }, {
          title: '创意传播',
          introduce1: '密切关注当下热门话题与潮流创意，发掘引爆热点，为品牌推广提供最有效的方式；',
          introduce2: '业务包含：品牌线上线下创意与传播策略定制，TVC，微电影，H5的制作等。'
        }, {
          title: '供应采购',
          introduce1: '灵活高效的供应采购管理体系，保证最快的速度、最优的质量、最低的成本；',
          introduce2: '业务包含：包材寻样、成本核算、物料采购、质量把控等。'
        }, {
          title: '成品输出',
          introduce1: '深耕中国消费者洞察，以消费者痛点驱动创新，致力为客户打造最好卖的产品；',
          introduce2: '业务包含：品牌孵化、产品开发、卖点提炼、产品备案、生产管理、成品输出等。'
        }, {
          title: '流程控管',
          introduce1: '专人专效的管理团队，完善的产品质量把控体系，用心打造以创意为核心驱动力的供应链条；',
          introduce2: '业务包含：原料把控、样板评测、生产监督、进度管理、成品检测、成品入库、售后服务等。'
        }]
      },
      work: {
        project: '项目',
        no_more_result: '没有更多作品了！:('
      },
      service: {
        letter: '按首字母',
        industry: '行业类别',
        project: '服务项目',
        introduce: 'OIB.CHINA先后帮助超过200个新消费品牌实现品牌型增长，正在成为中国新消费品领域中首屈一指的品牌增长加速器和新锐品牌孵化器。',
        classification1: '护肤',
        classification2: '彩妆',
        classification3: '面膜',
        classification4: '个护',
        classification5: '母婴',
        classification6: '食品'
      },
      about: {
        introduction: '公司简介',
        service: '业务板块',
        composition: '公司组织',
        parter: '合作伙伴',
        philosophy: '服务理念',
        // clients: '服务客户',
        ip: '独立IP',
        vision: '公司愿景',
        // 将“奖项”换成“新闻动态”
        awards: '新闻动态',
        people: '核心成员',
        peopleList: [{
          photoUrl: require('../../assets/img/about/people/wuzhigang.jpg'),
          name: '吴志刚',
          title: 'OIB.China 创始人',
          intro: '曾任上市公司与知名企业总经理、市场总监、事业部总经理，中国百货商业协会洗涤化妆品分会副秘书长；中国化妆品市场营销中心副主任；《化妆品观察》《中国美妆》主笔；《中国化妆品》《日用化学工业》《日用化学品科学》编委；中国化妆品营销十大策划人；荣获中国杰出营销人金鼎奖和中国广告长城奖。'
        }, {
          photoUrl: require('../../assets/img/about/people/chenjun.jpg'),
          name: '陈俊',
          title: '创意及供应链事业群总监',
          intro: '超过二十年的化妆品行业产品开发设计及形象管理工作经历，有极为丰富的创意管理及供应链管理经验，曾任多家知名上市化妆品公司设计总监，并负责过Max Factor、BOURJOIS的爆品设计及生产输出工作，OPPO、VIVO特供产品的生产输出工作等。'
        }, {
          photoUrl: require('../../assets/img/about/people/nongqian.jpg'),
          name: '农倩',
          title: '整合营销事业群总监',
          intro: '中山大学工商管理硕士，化妆品行业从业超过十年，具备甲方和乙方双重工作经历。2013年加入OIB.CHINA至今，历任玛丽黛佳、资生堂、百雀羚、法兰琳卡、妙巴黎等逾30个品牌的策略与整合营销传播项目负责人，擅长化妆品与时尚消费品领域的消费者洞察与品牌体系构建，亦对数字时代下的女性内容营销有较为深刻的洞见。'
        }, {
          photoUrl: require('../../assets/img/about/people/fenghao.jpg'),
          name: '冯浩',
          title: '供应链总监',
          intro: '曾先后任职大型时尚集团公司，历任经理，总监，总经理一职；先后服务国内大型化妆品品牌：珀莱雅，美肤宝，花印，金芦荟，荟宝等多个品牌，并负责过Max Factor, BOURJOIS, OPPO, VIVO爆品礼盒的生产供应工作；十多年来专注于供应链统筹管理，生产实施，流程化操作，运营，运输物流等供应链管理体系。'
        }, {
          photoUrl: require('../../assets/img/about/people/aiwentao.jpg'),
          name: '艾文涛',
          title: '艺术总监',
          intro: '近20年品牌创意设计及品牌视觉管理服务经验，服务品牌均为中国时尚行业领先品牌，尤其深谙中国传统美学与现代时尚融合之道，熟稔中国传统工艺与奢侈品定制，是中国首屈一指的奢侈品视觉管理专家，长期服务欧洲最大的供热集团德国威能/中国智能手机领导品牌VIVO/休闲食品领军品牌周黑鸭以及中国知名珠宝与服装品牌等，同时帮助多个创新品牌建立品牌定位策略及美学体系。'
        }, {
          photoUrl: require('../../assets/img/about/people/linzhanhua.jpg'),
          name: '林湛华',
          title: '超级产品策略总监',
          intro: '曾任职于品牌市场部、广告公司及媒体公司，熟悉产品开发及营销的整体链条运作，对产品差异卖点打造 、消费者营销语言转化、商业渠道突破拥有丰富实操经验。2014年加入OIB.China，聚焦时尚行业，参与国内外知名品牌超级产品打造，涵盖法国妙巴黎天鹅绒彩唇釉、唇色编辑口红、韩后旗下达人面膜、娇兰佳人旗下植物日记植酵水光系列等。'
        }, {
          photoUrl: require('../../assets/img/about/people/huanghe.jpg'),
          name: '黄河',
          title: '助理客户总监',
          intro: '从业8年，具备甲方和乙方双重工作经历。拥有丰富的母婴行业从业经验，曾在本土知名母婴连锁企业任职三年，涉及婴幼儿洗护、用品、服饰、婴儿泳疗、产后修复等领域；曾独立开发一款婴幼儿纸尿裤，成功申请实用新型和外观两项专利；多次统筹大型项目，含上海CBME孕婴童展、北京京正展、新品发布会和招商会等。'
        }, {
          photoUrl: require('../../assets/img/about/people/yuxiaohu.jpg'),
          name: '余晓虎',
          title: '客户总监',
          intro: '毕业于中山大学岭南 [ 大学 ] 学院MBA，超过10年化妆品OEM/ODM销售管理经验，曾任职于国内知名化妆品OEM公司销售总监，非常熟悉了解化妆品市场及客户需求，具有多个项目全程操盘营销管理及执行的经验，能独立并熟练操作项目营销策划所涉及的全部环节，擅长客户开拓、维护、业务团队培养管理。'
        }, {
          photoUrl: require('../../assets/img/about/people/chenyanan.jpg'),
          name: '陈亚男',
          title: '商务客户总监',
          intro: '曾任于品牌销售部，4年甲方从业经验，管理全渠道运营及销售，于2016年加入OIB.CHINA客户部。负责OIB集团项目商务运营和管理，推动公司业务发展，在入职期间与国内外知名化妆品集团建立长久战略合作服务客户：百雀羚、三生花、娇兰佳人、资生堂、玛丽黛佳、隆力奇、青蛙集团、优禾生活、袋鼠妈妈等等。'
        }, {
          photoUrl: require('../../assets/img/about/people/linzhipin.jpg'),
          name: '林志聘',
          title: '高级客户经理',
          intro: '曾任职于数字营销公司及广告公司，熟悉营销及大型活动的整体运作，对商业渠道突破拥有丰富实操经验。于2017年加入OIB.CHINA客户部。全面负责OIB集团项目运营和管理，推动公司销售业务，具有较强的项目运营力，在职期间与国内外知名化妆品集团建立长久战略合作关系，服务等客户如资生堂、玛丽黛佳等。'
        }, {
          photoUrl: require('../../assets/img/about/people/jinjing.jpg'),
          name: '金晶',
          title: '客户总监',
          intro: '2010 年曾任知名化妆品品牌经理。2013 年担任OIB.NX-DESIGN运营总监，全权负责公司的市场运作与管理，并参与公司首轮融资。2017年担任OIB.CHINA商务总监，具有较强的开拓和商务谈判能力。成功的服务众多知名品牌，与公司建立长久战略合作关系。'
        }, {
          photoUrl: require('../../assets/img/about/people/wenxiasha.jpg'),
          name: '温夏莎',
          title: '高级产品经理 | OIB.GCH国际项目经理',
          intro: '萨凡纳艺术与设计学院，奢侈品与时尚管理，硕士。欧美时尚行业海外工作经验，服务Abercrombie & Fitch Co., Philipp Plein 及 MO&Co.等高端品牌，职能涵盖市场营销、商品企划及零售管理等核心邻域。曾领导参与完成美国时尚名人领袖品牌Diana Vreeland家居香水线产品开发及系列营销企划。丰富的国际创意与设计资源，成熟的千禧消费者洞察、新兴品牌孵化、极致商品企划及跨国商务洽谈能力。'
        }, {
          photoUrl: require('../../assets/img/about/people/panliang.jpg'),
          name: '潘良',
          title: '商业智慧&品牌策略总监',
          intro: '专注化妆品及快速消费品行业研究数年，熟悉化妆品品牌策略定位、专业渠道推广、渠道营销策划、线上线下营销方法与执行、数字化精准营销手段，曾经服务诸多化妆品品牌：森田药妆、瑞薇琪、艾露德玛、梵萃等；2014年加入OIB.China，至今服务了OLAY、玛丽黛佳、一叶子、索薇娅、红色小象、百雀羚、帮宝适、魔力鲜颜、高柏诗、韩妙等诸多品牌。'
        }, {
          photoUrl: require('../../assets/img/about/people/zhuqianru.jpg'),
          name: '朱倩如',
          title: 'DAV创意副总监',
          intro: '毕业于伦敦艺术大学，数字艺术硕士学位，常年与不同领域的艺术家跨界合作，拥有丰富的国内外短视频制作经验。拥有自己的影像工作室，商业视频点击量达数百万；在伦敦创业，曾联合创立海外设计师平台Craft+，负责所有视频影像制作，成为腾讯民艺类原创视频首推内容。'
        }]
      },
      contact: [{
        address_title: 'Address 地址',
        address_content: '中国 上海市<br>黄浦区 瞿溪路691号<br>宏欣科技设计创意园一楼群108、110室<br><br>',
        business_title: 'Business 商务联系',
        business_content: ' 客户部<br>陈亚男<br> +86 186-1611-4594<br>emily.chen@oib-china.com'
      }, {
        address_title: 'Address 地址',
        address_content: '中国 广州市<br>天河区 珠江新城 冼村路11号<br/>保利威座2005-2006<br><br>',
        phone_title: 'Phone 座机',
        phone_content: '+86 (020) 3855-6155<br><br>',
        business_title: 'Business 商务联系',
        business_content: ' 策略中心<br/>彭丽珍<br> +86 135-6035-9426<br>peng@oib-china.com<br>'
      }, {
        business_title: 'Business 国际商务',
        business_content: ' 彭丽珍<br> +86 135-6035-9426<br>peng@oib-china.com<br>'
      }, {
        business_title: 'Business 商务联系',
        business_content: '陈俊<br> +86 138-2216-2619<br>june.chen@oib-china.com<br>'
      }, {
        address_title: 'Address 地址',
        address_content: ' 神戸市中央区港島南町５−５−２<br>神戸国際ビジネスセンター６０５美研創新（株）内<br><br>',
        business_title: 'Business 商务联系',
        business_content: '总经办<br/>朱小姐<br> +86 136-3238-4519<br>zhuzhiyi@oib-china.com<br>'
      }, {
        recruitment_title: 'Recruitment 人才招募',
        recruitment_content: ' Vicky Xin<br> +86 (020) 3855-6155<br>vicky@oib-china.com<br>'
      }]
    }
  }
};



// WEBPACK FOOTER //
// ./src/local/messages/index.js